import styled from 'styled-components';

export default styled.div`
	background: linear-gradient(119deg, var(--neutrals-bg-gradient1) 19.79%, var(--neutrals-bg-gradient2) 99.54%);
	position: absolute;
	top: 0;
	bottom: 0;
	right: -200%;
	width: 70%;
	border: var(--px-1) solid var(--neutrals-300);
	box-shadow: calc(var(--px-8) * -1) 0 var(--px-8) rgba(0, 0, 0, 0.07);
	animation: 0.4s 1 normal slidein;
	animation-fill-mode: forwards;

	display: flex;
	flex-direction: column;

	@keyframes slidein {
		from {
			right: -110%;
		}

		to {
			right: 0;
		}
	}
`;
